import React, { useEffect, useState, useRef } from "react";
import { bindElements, getPlayerState } from "../../../utils/amplitude-util";

import { Box, Stack, Slider } from "@mui/material";
export default function SongSlider({ style }) {
  let globalSongSlider = useRef(null);
  let [globalSongProgress, setGlobalSongProgress] = useState(0);
  function handleSongSliderChange(event, value) {
    setGlobalSongProgress(value);
    //for chrome and fire fox
    let event1 = new Event("input");
    //for ie
    let event2 = new Event("change");
    globalSongSlider.current.value = value;
    globalSongSlider.current.dispatchEvent(event1);
    globalSongSlider.current.dispatchEvent(event2);
  }
  useEffect(() => {
    bindElements();
    console.log("songslider mount", globalSongSlider);
    globalSongSlider.current.oninput = function (value) {
      setGlobalSongProgress(value);
    };
    globalSongSlider.current.onchange = function (value) {
      setGlobalSongProgress(value);
    };
  }, []);
  return (
    <Box style={{ width: "100%" }}>
      <input
        style={{ display: "none" }}
        ref={globalSongSlider}
        type="range"
        className="amplitude-song-slider"
      />
      <Stack
        spacing={2}
        style={{ display: "box", ...style }}
        direction="row"
        sx={{ mb: 1 }}
        alignItems="center">
        <Slider
          root="amplitude-song-slider"
          aria-label="Volume"
          value={globalSongProgress}
          size="small"
          onChange={handleSongSliderChange}
        />
      </Stack>
    </Box>
  );
}
